"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCommentSolid(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 1C5.411 1 0 5.162 0 10.407l.006.267c.123 2.933 2.26 5.618 5.054 6.93l-.003.05c-.1.82-.416 1.703-.89 2.593-.208.39-.43.752-.652 1.076-.132.192-.231.325-.283.39a.766.766 0 00.618 1.244l.24-.012c.23-.016.531-.047.887-.101.83-.126 1.66-.336 2.443-.652l.285-.121c1.124-.5 2.035-1.193 2.65-2.113l.04-.064H12c6.571 0 12-4.229 12-9.487C24 5.162 18.589 1 12 1z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCommentSolid;
exports.default = _default;